import * as OB1Common from "./ob1-common";

/**
 * configuration du nombre d'éléments par slide selon la taille de l'écran
 */
function computeItemsPerSlide(container) {

  const componentWidth = container.offsetWidth;

  // version plages horaires
  if (container.classList.contains("ob1-date-time-picker-slots")) {
    if (componentWidth >= 960) { // Extra large et XX large
      return 7;
    } else if (componentWidth >= 736) { // Large
      return 5;
    } else if (componentWidth >= 480) { // Medium
      return 4;
    }

    // version horaires fixes
  } else {
    if (componentWidth >= 736) { // Large, Extra large et XX large
      return 7;
    } else if (componentWidth >= 480) { // Medium
      return 5;
    }
  }
  return 1;
}

/**
 * formatage du header de colonne date
 * @param localDateIsoStr - ex : "2022-07-16"
 * @returns {string} - ex : "samedi <br class='d-none d-md-inline' />16 juil."
 */
function formatDateHeader(localDateIsoStr) {
  const localDateFrStr = new Date(
    localDateIsoStr.slice(0, 4),
    Number(localDateIsoStr.slice(5, 7)) - 1,
    localDateIsoStr.slice(8)
  ).toLocaleDateString("fr-FR", { weekday: "long", month: "short", day: "2-digit" });
  const dateElts = localDateFrStr.split(" ");
  return dateElts[ 0 ] + "\u0020" + "<br class='d-none d-md-inline' />" + dateElts[ 1 ] +
    "\u00A0" + dateElts[ 2 ];
}

class DateTimePicker {

  /**
   * Initialisation du Date Time Picker
   */
  init(container, proposals) {
    this.container = container;
    const dateTimes = proposals && proposals.datesTimes;
    if (!Array.isArray(dateTimes)) {
      return;
    }

    const nbItemsPerSlide = computeItemsPerSlide(container);

    const nbDateTimeItems = dateTimes.length;
    let K = 0;
    let slideIndex = 0;

    const nbTimeSlotsMax = dateTimes
      .reduce((accumulator, currentValue) => Math.max(accumulator, Object.keys(currentValue.hourProposals).length), 0);

    // en-tete du swiper
    let componentHtml = "<div class=\"swiper-container\"><div class=\"swiper-wrapper d-flex swiper-content mb-0\">";

    // on boucle X fois sur la liste des dates en fonction du nombre de dates souhaitees par slides
    while (K < nbDateTimeItems) {

      K = K + nbItemsPerSlide;

      // conteneur de chaque slide
      componentHtml += `<div class="swiper-slide w-100 pt-2 pt-md-0 swiper-item" id="slide${slideIndex}">
              <div class="d-flex justify-content-between">
                <div class="ob1-date-time-picker-arrow"></div>`;

      slideIndex++;

      // pour chaque slide, on affiche les X dates correspondantes
      for (let i = K - nbItemsPerSlide; i < K; i++) {

        const entry = dateTimes[ i ];
        if (entry != null) {
          const dateHeader = formatDateHeader(entry.dateProposals);
          const timeItems = Object.keys(entry.hourProposals);

          componentHtml += "<div class='text-md-center ob1-date-time-picker-day-times'>";

          // affichage de chaque jour
          if (timeItems.length) {
            componentHtml += `<div class="date-title mx-auto">${dateHeader}</div>`;

            // affichage des boutons en fonction de la disponibilité pour sélection de l'heure
            for (const hour of timeItems) {
              const status = entry.hourProposals[ hour ];
              let statusClass = "hour-disable";
              if (status === "AVAILABLE") {
                statusClass = "";
              } else if (status === "SELECTED") {
                statusClass = "selected";
              }
              componentHtml += `<button
                                  class="btn-hour selectDateHour ${statusClass}"
                                  type="button"
                                  data-date="${entry.dateProposals}" data-hour="${hour}"
                                  ${statusClass === "hour-disable" ? "disabled" : ""}>${hour}</button>`;
            }

            // remplissage pour aligner au contenu max
            for (let j = timeItems.length; j < nbTimeSlotsMax; j++) {
              componentHtml += "<button class=\"btn-hour selectDateHour hour-disable\" disabled>-</button>";
            }
          } else {

            // s'il n'y a aucun horaire pour la journée, affichage d'une info sur petits écrans
            componentHtml += `<div class="date-title disabled">${dateHeader}</div>
                              <div class="d-md-none px-0">
                                <div class="alert-container alert-info px-2" role="alert">
                                  <p class="alert">
                                    <span class="alert-icon" aria-hidden="true"></span>
                                    <span class="ob1-alert-title text-left">
                                      Aucun horaire disponible pour cette journée
                                    </span>
                                  </p>
                                </div>
                              </div>`;

            // et de - sur grands écrans
            for (let j = 0; j < nbTimeSlotsMax; j++) {
              componentHtml += "<button class='btn-hour hour-disable d-none d-md-block' disabled>-</button>";
            }
          }
          componentHtml += "</div>";
        }
      }

      componentHtml += "<div class=\"ob1-date-time-picker-arrow\"></div></div></div>";
    }

    // affichage des boutons du swiper
    componentHtml += `</div>
         <div class="swiper-button-prev d-none d-md-block" title="Précédant"></div>
         <div class="swiper-button-next d-none d-md-block" title="Suivant"></div>
      </div>
      <!-- BOUTONS TEXTUELS SUPPLEMENTAIRES DE SWIPE : VERSION DESKTOP UNIQUEMENT -->
      <div class="row my-3 d-none d-md-flex">
         <div class="col-6 text-right"><button class="btn btn-secondary disabled swipeLeft"
             id="prevDayButton">Jours précédents</button></div>
         <div class="col-6"><button class="btn btn-secondary swipeRight"
             id="nextDayButton">Prochains jours</button></div>
      </div>`;

    // Injection du contenu HTML généré
    this.container.innerHTML = componentHtml;

    // Initialisation du swiper
    this.mySwiper = new Swiper(".swiper-container", {
      autoplay: false,

      // enable accessibility
      a11y: true,
      keyboard: {
        enabled: true,
        onlyInViewport: false
      },
      freeMode: false,

      // If we need pagination
      pagination: false,

      // Navigation arrows
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      slidesPerView: 1,
      centeredSlides: true,

      on: {
        slideChange: () => {
          this.isSwiperAtBeginning();
          this.isSwiperAtEnd();
        }
      }
    });

    // Ajout de nouvelles fonctionnalités de swipe pour les différents boutons
    this.dateTimePickerSwiper = this.container.querySelector(".swiper-container").swiper;

    // gestion de l'évenement resize du navigateur
    this._onResize = () => {
      this.changeDisplayMode();
    };
    window.addEventListener("resize", this._onResize);

    // Appel de la méthode d'affichage du swiper ou non, au chargement
    this.changeDisplayMode();

    // Gestion des écouteurs
    this._onClick = (event) => {
      if (event.target.classList.contains("swipeLeft")) {
        this.swipeLeft();
      } else if (event.target.classList.contains("swipeRight")) {
        this.swipeRight();
      } else if (event.target.classList.contains("selectDateHour")) {
        this.setDateTimeForm(event.target);
      }
    };
    this.container.addEventListener("click", this._onClick);
  }

  swipeLeft() {
    this.dateTimePickerSwiper.slidePrev();
    this.isSwiperAtBeginning();
  }

  swipeRight() {
    this.dateTimePickerSwiper.slideNext();
    this.isSwiperAtEnd();
  }

  swipeToNextAvailableDate(slideIndex) {
    this.dateTimePickerSwiper.slideTo(slideIndex);
  }

  isSwiperAtBeginning() {
    const button = this.container.querySelector("#prevDayButton");
    if (this.dateTimePickerSwiper.isBeginning === true) {
      button.classList.add("disabled");
    } else {
      button.classList.remove("disabled");
    }
  }

  isSwiperAtEnd() {
    const button = this.container.querySelector("#nextDayButton");
    if (this.dateTimePickerSwiper.isEnd === true) {
      button.classList.add("disabled");
    } else {
      button.classList.remove("disabled");
    }
  }

  // affichage ou masquage du swiper en fonction de la résolution
  changeDisplayMode() {
    this.dateTimePickerSwiper = this.container.querySelector(".swiper-container").swiper;
    const swiperContent = this.container.querySelector(".swiper-content");
    const swiperItem = this.container.querySelector(".swiper-item");
    const w = document.documentElement.clientWidth;
    if (w < OB1Common.breakpoints.MEDIUM) {
      this.dateTimePickerSwiper.allowSlidePrev = false;
      this.dateTimePickerSwiper.allowSlideNext = false;
      swiperContent.classList.remove("swiper-wrapper", "d-flex");
      swiperItem.classList.remove("swiper-slide");
      swiperItem.style.width = "100%";
      this.dateTimePickerSwiper.slideTo(0);
    } else {
      this.dateTimePickerSwiper.allowSlidePrev = true;
      this.dateTimePickerSwiper.allowSlideNext = true;
      swiperContent.classList.add("swiper-wrapper", "d-flex");
      swiperItem.classList.add("swiper-slide");
      this.dateTimePickerSwiper.slideTo(0);
    }
  }

  /**
   * fonction pour passer aux champs cachés la valeur sélectionnée par l'utilisateur
   * @param elt - le bouton d'horaire cliqué
   */
  setDateTimeForm(elt) {
    const selectedButton = this.container.querySelector("button.selected");
    if (selectedButton != null) {
      selectedButton.classList.remove("selected");
    }
    elt.classList.add("selected");

    const dateInput = document.getElementById("selectedDate") ||
      document.querySelector(`input[data-name="selectedDate-${this.container.getAttribute("data-name")}"]`);
    if (dateInput) {
      dateInput.value = elt.dataset.date;
    }

    const timeInput = document.getElementById("selectedTime") ||
      document.querySelector(`input[data-name="selectedTime-${this.container.getAttribute("data-name")}"]`);
    if (timeInput) {
      timeInput.value = elt.dataset.hour;
    }
  }

  constructor(container, proposals) {
    if (container) {
      if (typeof container.dataset.ref === "undefined") {
        this.ref = Math.random();
        DateTimePicker.refs[ this.ref ] = this;
        container.dataset.ref = this.ref;
        this.init(container, proposals);
      } else {

        // If this element has already been instantiated, use the existing reference.
        return DateTimePicker.refs[ container.dataset.ref ];
      }
    }
  }

  /**
   * Décharge le composant
   */
  dispose() {
    window.removeEventListener("resize", this._onResize);
    this.container.removeEventListener("click", this._onClick);
  }
}

DateTimePicker.refs = {};

// rattachement au contexte window pour pouvoir l'utiliser en dehors du JS
window.DateTimePicker = DateTimePicker;

export default DateTimePicker;
